<template>
	<div>
		<!--弹出框-->
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%;">
			<el-dialog :title="titmc" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
				<el-row>
					<el-col :span="12">
						<el-form-item type="type" label="物资名称" prop="wzmc">
							<el-input type="type" class="from-el-input" placeholder="应急物资名称" v-model.trim="ruleForm.wzmc" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item type="type" label="物资类型" prop="wzlx">
              <el-select :disabled="states=='ck'" v-model.trim="ruleForm.wzlx" class="from-el-input" placeholder="应急物资类型">
              	<el-option v-for="(item,i) in wzlist" :key="i" :label="item.name" :value="item.code">
              	</el-option>
              </el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
				</el-row>
				<el-row>
					<el-col :span="12">
            <addressTree @obj="objdata" @close="treeClose" :currentdata="currentData"></addressTree>
					</el-col>
					<el-col :span="12">
						<el-form-item type="type" label="规格型号" prop="ggxh">
							<el-input type="type" class="from-el-input" placeholder="规格型号" v-model.trim="ruleForm.ggxh" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
        <el-row>
        	<el-col :span="12">
        		<el-form-item type="type" label="购置数量" prop="nums">
              <el-input type="type" class="from-el-input" placeholder="购置数量" v-model.trim="ruleForm.nums" :disabled="states=='ck'"></el-input>
        		</el-form-item>
        	</el-col>
          <el-col :span="12">
          	<el-form-item type="type" label="购置日期" prop="fdate">
          		<el-date-picker v-model.trim="ruleForm.fdate" type="date" class="from-el-input-item" value-format="yyyy-MM-dd" placeholder="编制日期" :disabled="states=='ck'"></el-date-picker>
          	</el-form-item>
          </el-col>
        </el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item type="type" label="责任人" prop="zrr">
					    <el-input type="type" class="from-el-input" placeholder="管理责任人" v-model.trim="ruleForm.zrr" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
          <el-col :span="12">
          	<el-form-item type="type" label="联系方式" prop="zrrlxfs">
              <el-input type="type" class="from-el-input" placeholder="责任人联系方式" v-model.trim="ruleForm.zrrlxfs" :disabled="states=='ck'"></el-input>
          	</el-form-item>
          </el-col>
				</el-row>
        <el-row>
        	<el-col :span="12">
        		<el-form-item type="type" label="生产厂家" prop="sccj">
        	    <el-input type="type" class="from-el-input" placeholder="生产厂家" v-model.trim="ruleForm.sccj" :disabled="states=='ck'"></el-input>
        		</el-form-item>
        	</el-col>
          <el-col :span="12">
          	<el-form-item type="type" label="联系方式" prop="sccjlxfs">
              <el-input type="type" class="from-el-input" placeholder="生产厂家联系方式" v-model.trim="ruleForm.sccjlxfs" :disabled="states=='ck'"></el-input>
          	</el-form-item>
          </el-col>
        </el-row>
        <el-row>
        	<el-col :span="12">
        		<el-form-item type="type" label="落实状态" prop="lszt">
              <el-select :disabled="states=='ck'" v-model.trim="ruleForm.lszt" class="from-el-input" placeholder="落实状态">
              	<el-option v-for="(item,i) in lslist" :key="i" :label="item.name" :value="item.code">
              	</el-option>
              </el-select>
        		</el-form-item>
        	</el-col>
        </el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item type="type" label="简要说明" prop="jysm">
							<el-input type="textarea" :rows="3" class="from-el-input-text" placeholder="简要说明" v-model.trim="ruleForm.jysm" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="states=='xz'||states=='bj'">
				  <el-col :span="24">
				    <div class="titna">
				      <span class="addSpan">附件</span>
				    </div>
				    <div class='fujian'>
				      <el-upload class="upload-demo" drag action="" multiple :on-remove="handleRemove" :on-change='changes'
				        :file-list="fileList" :limit="5" :auto-upload='false'>
				        <i class="el-icon-upload"></i>
				        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				      </el-upload>
				      <div class='fujian fujians' v-if="filetabledata.length!=0">
				        <ul class="fjhxlist">
				          <li v-for="(item,i) in filetabledata" :key="i">
				            <div class="names" style="text-align: left;">{{item.sourceName}}</div>
				            <div class="names cz">
				              <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
				              <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item)"
				                class="btnmargin"></el-button>
				            </div>
				          </li>
				        </ul>
				      </div>
				    </div>
				  </el-col>
				</el-row>
				<el-row v-if="states=='ck' && filetabledata.length!=0">
				  <el-col :span="24">
				    <div class="titna">
				      <span class="addSpan">附件</span>
				    </div>
				    <div class='fujian'>
				      <ul class="fjhxlist">
				        <li v-if="filetabledata.length==0" style='width:100%;height:80px;line-height: 80px;color:#ccc'>暂无附件,请上传！</li>
				        <li v-for="(item,i) in filetabledata" :key="i" v-if="filetabledata.length!=0">
				          <div class="names" style="text-align: left;">{{item.sourceName}}</div>
				          <div class="names cz">
				            <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
				            <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item)"
				              class="btnmargin"></el-button>
				          </div>
				        </li>
				      </ul>
				    </div>
				  </el-col>
				</el-row>
        <el-row class="rowTop" style="margin-top:15px">
        	<el-col :span="8">
        		<el-form-item type="type" label="经度坐标" prop="lats">
        			<el-input type="type" :disabled="states=='ck'" class="from-el-input" placeholder="经度坐标" v-model.trim="ruleForm.lngs"></el-input>
        		</el-form-item>
        	</el-col>
        	<el-col :span="8">
        		<el-form-item type="type" label="纬度坐标" prop="lats">
        			<el-input type="type" :disabled="states=='ck'" class="from-el-input" placeholder="纬度坐标" v-model.trim="ruleForm.lats"></el-input>
        		</el-form-item>
        	</el-col>
        	<el-col :span="8" v-if="mystate[1]!='homeyh'">
        		<el-button :disabled="states=='ck'" size="mini" type="primary" @click="supclick()" style="float: right;margin-left: 20px; margin-top: 10px;">点击拾取位置</el-button>
        	</el-col>
        </el-row>
        <el-row class="rowTop">
        	<el-col style="width: 100%;height: 400px;">
        		<supgiscomponent :disabled="states=='ck'" :mapChliddata="mapchliddata" :mapClickstate="mapclickstate" :latlngs="latlngs" @changeData="changeData" @clickData="clickData"></supgiscomponent>
        	</el-col>
        </el-row>
				<span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button v-if="states !== 'ck'" @click="cancel()" type="warning">取 消</el-button>
            <el-button v-if="states == 'xz'" type="success" @click="xzdeteRmine('ruleForm','xz')">保 存</el-button>
            <el-button v-if="states == 'bj'" type="success" @click="xzdeteRmine('ruleForm','bj')">保 存</el-button>
          </el-form-item>
        </span>
			</el-dialog>
		</el-form>
	</div>
</template>
<script>
  import { ydbjbxxQuery, yjwzSave, yjwzUpdate, dictioninfo, deleteFile } from "@/api/api";
  import supgiscomponent from "@/components/visualization/supgisComponent.vue"
  import addressTree from '@/components/mangement/popupaddressTree.vue';
  import axios from 'axios'
	let date = new Date()
  const currentFdate = date.getFullYear() + '-' + (date.getMonth()+1) + '-'+ date.getDate() + ' ' + date.getHours()+':'+date.getMinutes()+':'+date.getSeconds();
	export default {
		props: {
			mystate: Array
		},
		data() {
			return {
				editDisable: false,
				dialogVisible: true, // 弹出框显示
				titmc: '应急物资信息',
				ruleForm: {
					wzmc: '', // 物资名称
					wzlx: '', // 分类名称
          ydbName: '', // 淤地坝名称
          ydbCode: '', // 淤地坝编码
          ggxh: '', // 规格型号
          nums: '',
          zrr: '',
          zrrlxfs: '',
          sccj: '',
          sccjlxfs: '',
					jysm: '',
					fdate: String(currentFdate),
          lszt: '',
          lats: '',
          lngs: '',
				},
				rules: {
					wzmc: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
					wzlx: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
          ydbName: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' }
          ],
          ggxh: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          nums: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          zrr: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          zrrlxfs: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          sccj: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          sccjlxfs: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
					fdate: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
					jysm: [
						{ required: false, message: '请输入必填项', trigger: 'blur' },
            { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
          lats: [
          	{ required: true, message: '请输入必填项', trigger: 'change' }
          ],
          lngs: [
          	{ required: true, message: '请输入必填项', trigger: 'change' }
          ]
				},
        mapclickstate: false,
        mapchliddata: null,
        latlngs: null,
				states: '',
				wzlist: [],
        lslist: [],
				fileList: [], // 附件
				filetabledata: [], // 回显附件
        currentData: '',
        row: null,
        fileUrl: '',
			}
		},
		cerate() {
			// 初始化数据
		},
		methods: {
      //获取物资类型数字字典
      getwzlxinfo() {
        let params = {
          type: 'wzlx',
          code: 'state'
        };
        dictioninfo(params).then((res) => {
          this.wzlist = res.data;
        })
      },
      //获取物资落实状态数字字典
      getwzlsinfo() {
        let params = {
          type: 'yjwzgl',
          code: 'state'
        };
        dictioninfo(params).then((res) => {
          this.lslist = res.data;
        })
      },
      list(params) {
        let _this = this;
        ydbjbxxQuery(params).then((res) => {
          if (res.data.length !== 1) {
            _this.$notify({
              title: "提示",
              message: "请选择淤地坝",
              type: "warning"
            });
          } else {
            _this.ruleForm.ydbCode = res.data[0].ydbCode;
            _this.ruleForm.ydbName = res.data[0].ydbName;
          }
        })
      },
      treeClose(){
      },
      objdata(data) {
      	let params = {
      		ydbCode:data.ydbCode
      	};
      	this.list(params);
      },
			handleClose(done) {
				this.dialogVisible = false
				this.$emit('getcancel', { dialogVisible: this.dialogVisible })
			},
			cancel() {
				// 取消
				this.dialogVisible = false
				this.$emit('getcancel', { dialogVisible: this.dialogVisible })
			},
			xzdeteRmine(formName, states) { //确定
        this.$refs[formName].validate(valid => {
          if (valid) {
            let config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }; // 添加请求头
            if (this.fileList.length != 0) {
              let formData = new FormData();
              this.fileList.forEach((el, index) => {
                formData.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });

              axios.post('/userApi/minio/updateFileMulti', formData, config).then(res => {
                if (res.data.code == 200) {
                  this.$notify({
                    title: "提示",
                    message: res.data.message,
                    type: "success",
                  });
                  this.fileUrl = res.data.data;
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.data.message,
                    type: "warning",
                  });
                }
              }).catch(err => {});
            }

            let _this = this;
            setTimeout(function() {
              if (states == 'xz') {
                let params = {
                  ydbWzMc: _this.ruleForm.wzmc, //物资名称
                  ydbWzlx: _this.ruleForm.wzlx, //物资类型
                  ydbName: _this.ruleForm.ydbName, //淤地坝名称
                  ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                  ydbGgxh: _this.ruleForm.ggxh, //规格型号
                  ydbGzsl: _this.ruleForm.nums, //购置数量
                  ydbGzqr: _this.ruleForm.fdate, //购置日期
                  ydbZrr: _this.ruleForm.zrr, //责任人
                  ydbZrrLxfs: _this.ruleForm.zrrlxfs, //责任人联系方式
                  ydbSccj: _this.ruleForm.sccj, //生产厂家
                  ydbSccjLxfs: _this.ruleForm.sccjlxfs, //生产厂家联系方式
                  status: _this.ruleForm.lszt, //状态
                  ydbJysm: _this.ruleForm.jysm, //简要说明
                  ydbJingDu: _this.ruleForm.lngs, //经度
                  ydbWeiDu: _this.ruleForm.lats, //纬度
                  ydbFuJian: _this.fileUrl, //附件
                };
                yjwzSave(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("adddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              } else {
                let zhuangtai, leixing;
                if (_this.ruleForm.wzlx === '防汛物资') {
                  leixing = 0;
                } else {
                  leixing = 1;
                }
                if (_this.ruleForm.lszt === '已落实') {
                  zhuangtai = 0;
                } else {
                  zhuangtai = 1;
                }
                let params = {
                  ydbWzMc: _this.ruleForm.wzmc, //物资名称
                  ydbWzlx: leixing, //物资类型
                  ydbName: _this.ruleForm.ydbName, //淤地坝名称
                  ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                  ydbGgxh: _this.ruleForm.ggxh, //规格型号
                  ydbGzsl: _this.ruleForm.nums, //购置数量
                  ydbGzqr: _this.ruleForm.fdate, //购置日期
                  ydbZrr: _this.ruleForm.zrr, //责任人
                  ydbZrrLxfs: _this.ruleForm.zrrlxfs, //责任人联系方式
                  ydbSccj: _this.ruleForm.sccj, //生产厂家
                  ydbSccjLxfs: _this.ruleForm.sccjlxfs, //生产厂家联系方式
                  status: zhuangtai, //状态
                  ydbJysm: _this.ruleForm.jysm, //简要说明
                  ydbJingDu: _this.ruleForm.lngs, //经度
                  ydbWeiDu: _this.ruleForm.lats, //纬度
                  ydbFuJian: _this.fileUrl, //附件
                  id: _this.row.id
                };
                if (params.ydbFuJian === '') {
                  params.ydbFuJian = null;
                }
                yjwzUpdate(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("bjadddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              }
            }, 200)
          }
        });
      },

			DownloadFile(index, row) {
				// 下载文件
        window.open("/userApi/minio/downloadFile/" + row.fileName);
			},
			deletesfile(index, row) {
				// 删除文件
        let params = {id:row.id, fileName:row.fileName};
        deleteFile(params).then((res) => {
        	if(res.code == 200) {
        		this.$notify({
        			title: '',
        			message: res.message,
        			type: 'success'
        		});
        		this.filetabledata.splice(index, 1)
        	}
        })
			},

			handleRemove(file, fileList) {
				// 删除文件
        for (let i = 0; i < this.fileList.length; i++) {
          if (file.name == this.fileList[i].name) {
            this.fileList.splice(this.fileList[i], 1);
          }
        }
			},

			changes(file, fileList) {
				let num = 1024.0
				if(Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
					fileList.splice(fileList.length - 1, 1)
					this.$message.error('选择文件大于10M，请重新选择！')
				} else {
					this.fileList.push(file.raw)
				}
			},

      changeData(data) {
      	this.ruleForm.lats = data.properties.LAT;
      	this.ruleForm.lngs = data.properties.LON;
      	this.latlngtext = this.ruleForm.lats + ',' + this.ruleForm.lngs;
      },

      clickData(data) {
      	this.ruleForm.lats = data.latlng.lat;
      	this.ruleForm.lngs = data.latlng.lng;
      	this.latlngtext = this.ruleForm.lats + ',' + this.ruleForm.lngs;
      },

      supclick() {
      	this.mapclickstate = true;
      },
		},
		components: {
      supgiscomponent,
      addressTree
		},
		mounted() {
      this.getwzlsinfo();
      this.getwzlxinfo();

      this.states = this.mystate[0];
      this.row = this.mystate[1];
      if (this.states == 'bj' || this.states == 'ck') {
        this.currentData = this.mystate[1].ydbName; //淤地坝名称

        this.ruleForm.wzmc = this.mystate[1].ydbWzMc; //物资名称
        this.ruleForm.wzlx = this.mystate[1].ydbWzlx; //物资类型
        this.ruleForm.ydbName = this.mystate[1].ydbName; //淤地坝名称
        this.ruleForm.ydbCode = this.mystate[1].ydbCode; //淤地坝编号
        this.ruleForm.ggxh = this.mystate[1].ydbGgxh; //规格型号
        this.ruleForm.nums = this.mystate[1].ydbGzsl; //购置数量
        this.ruleForm.fdate = this.mystate[1].ydbGzqr; //购置日期
        this.ruleForm.zrr = this.mystate[1].ydbZrr; //责任人
        this.ruleForm.zrrlxfs = this.mystate[1].ydbZrrLxfs; //责任人联系方式
        this.ruleForm.sccj = this.mystate[1].ydbSccj; //生产厂家
        this.ruleForm.sccjlxfs = this.mystate[1].ydbSccjLxfs; //生产厂家联系方式
        this.ruleForm.jysm = this.mystate[1].ydbJysm; //简要说明
        this.ruleForm.lngs = this.mystate[1].ydbJingDu; //经度
        this.ruleForm.lats = this.mystate[1].ydbWeiDu; //纬度

        this.filetabledata = this.mystate[1].ydbFuJian;

        this.latlngs = {lat: this.ruleForm.lats, lng: this.ruleForm.lngs};

        if (this.mystate[1].ydbWzlx === 0) {
          this.ruleForm.wzlx = '防汛物资';
        } else {
          this.ruleForm.wzlx = '其他物资';
        }

        if (this.mystate[1].status === 0) {
          this.ruleForm.lszt = '已落实'; //状态
        } else {
          this.ruleForm.lszt = '未落实'; //状态
        }
      }
    }
	}
</script>

<style scoped>
  >>>.el-dialog__body {
  	height: 450px;
  	overflow: auto;
  }

  >>>.el-input--prefix .el-input__inner {
    padding-left: 30px;
  }

  .treebox {
    width: 100%;
    margin: 0;
  }

  .datepicker {
    padding-left: 30px;
  }

	.fujian {
    width: -webkit-calc(100% - 102px);
    width: -moz-calc(100% - 102px);
    width: calc(100% - 102px);
		float: left;
		border: 1px solid #ccc;
		border-radius: 4px;
		padding: 10px;
	}
</style>
